import { Transport } from './Transport.mjs';
import { isLogEvent } from '../validation.mjs';

/**
 * Transport for writing logger events to console.
 *
 * @class
 * @method handleEvent
 * @static defaultOpts
 * @static initialize
 */
class ConsoleTransport extends Transport {
  /** @constructor */
  constructor(opts) {
    super(opts);
  }

  /**
   * Event listener function
   *
   * @param {Event} event
   */
  handleEvent(event) {
    if (!isLogEvent(event)) {
      throw new TypeError('invalid event received');
    }

    const method = event.type.replace(/^log/, '');
    /* eslint-disable-next-line no-console, security/detect-object-injection */
    if (console[method]) {
      /* eslint-disable-next-line no-console, security/detect-object-injection */
      console[method](event.detail);
    }
  }
}

ConsoleTransport.defaultOpts = Object.freeze({});

export {
  ConsoleTransport as default,
  ConsoleTransport
};
